
seedWebApp.controller('EditPricesCtrl', ['$scope', '$uibModalInstance', '$window', 'StoreService', '$timeout', 'order', 'detail',
    function EditPricesCtrl($scope, $uibModalInstance, $window, StoreService, $timeout, order, detail) {
        console.log('EditPricesCtrl');
        console.log(detail);

        $scope.order = order;
        $scope.detail = detail;

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.openNewTab = function (version) {
            var newUrl = version.Image;
            $window.open(newUrl, '_blank');
            $scope.cancel();
        };

        $scope.doPrint = function () {
            $window.print();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
]);